import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { DtbMetricItem } from '../../_types/policy';
import _ from 'lodash';

export const getDtbMetrics = async (
  orgId: string,
  params: Record<string, any> = {},
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void,
) => {
  const url = `${baseApiUrl()}/activity-center/v1/organizations/${orgId}/policy/dtb-metrics`;

  const paramString = new URLSearchParams(
    Object.entries({
      ...params,
    })
      .filter(([_k, v]) => !_.isEmpty(v))
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}),
  ).toString();

  try {
    const metrics = await fetcher({
      method: 'get',
      url: `${url}?${paramString}`,
      options: { signal },
    });
    return metrics;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    console.warn('error retrieving dtb metrics');
    throw error;
  }
};

export default function useDtbMetrics(
  orgId: string,
  params: Record<string, any> = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void,
) {
  return useQuery<DtbMetricItem[], Error>(
    ['dtb_metrics', orgId, params],
    async ({ signal }): Promise<DtbMetricItem[]> => {
      return getDtbMetrics(orgId, params, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: 1000 * 60 * 15, // 15 minutes
    },
  );
}
